import type { FlightDataSource } from '@/lib/flights/types';

// The shape and tones of the provenance badge (`source-badge.tsx`) — constants
// apart so the board row can use them on its own element (fast refresh needs a
// component file to export components only).

/** Badge shape: tiny, so it fits a board row or a picker row without widening it. */
export const SOURCE_BADGE_CLASS =
  'inline-block max-w-full truncate rounded-sm border px-1 py-px font-sans text-[9px] font-semibold uppercase leading-none tracking-wide';

/** Tone per source. The airline (the source of truth) takes the tenant's primary
 *  token; the predictor and a file stay neutral tokens; synthetic is the violet
 *  Proveedores uses for its synthetic mode, so demo data never passes as live. */
export const SOURCE_TONE: Record<FlightDataSource, string> = {
  SERVICE_PROVIDER: 'border-primary/40 bg-primary/10 text-primary',
  PREDICTOR: 'border-border bg-muted text-muted-foreground',
  FILE: 'border-border bg-background text-foreground',
  SYNTHETIC:
    'border-violet-500/40 bg-violet-500/10 text-violet-700 dark:border-violet-400/40 dark:text-violet-300',
};
